import { map } from 'nanostores';

type LayoutStore = {
  title: string;
}
export const $layoutStore = map<LayoutStore>();
